import React, { useState, useEffect, useContext } from "react";
import SglContext from "../SglContext";
import "./billingMessages.css";
import AgreementDetail from "./AgreementDetail";
import SetDefaultPaymentMethod from "./SetDefaultPaymentMethod";


function BillingMessages(props) {
    const Sgl = useContext(SglContext);
    const [unsignedAgreements, setUnsignedAgreements] = useState([])
    const [displayAgreement, setDisplayAgreement] = useState(false)
    const [selectedAgreement, setSelectedAgreement] = useState(null)
    const [displayPaymentMethods, setDisplayPaymentMethods] = useState(false)

    useEffect(() => {
        setUnsignedAgreements(Sgl.unsignedAgreements ?? [])
    }, [Sgl.unsignedAgreements])

    // Agreement Functions >>>
    const openAgreementDetail = (agreement) => {
        setSelectedAgreement(agreement)
        setDisplayAgreement(true)
    }

    const closeAgreementDetail = () => {
        setSelectedAgreement(null)
        setDisplayAgreement(false)
    }

    const renderUnsignedAgreements = () => {
        return (
            unsignedAgreements?.length > 0 ? 
            unsignedAgreements.map((unsignedAgreement) => (
                <div className="billingMessages" key={unsignedAgreement?.id}>
                    <div className="div-responsive">
                        <div className="message-detail">
                            <div className="agreement-message">
                                <h3>{unsignedAgreement?.title}</h3>
                                <p>{unsignedAgreement?.description}</p>
                            </div>

                            <a className="billing-link" style={{ textDecoration: "underline" }} onClick={() => openAgreementDetail(unsignedAgreement)}>
                                Sign Agreement
                            </a>
                        </div>
                    </div>
                </div>
            ))
            : null
        )
    }
    // Agreement Functions <<<

    // Payment Methods Functions >>>
    const openDefaultPaymentMethod = () => {
        setDisplayPaymentMethods(true)
    }

    const closeDefaultPaymentMethod = () => {
        setDisplayPaymentMethods(false)
    }

    const renderDefaultPaymentMethod = () => {

        let hasDefaultPaymentMethod = Sgl.hasDefaultPaymentMethod

        return (
            !hasDefaultPaymentMethod && unsignedAgreements?.length <= 0 ?
            <>
            <div className="billingMessages">
                <div className="div-responsive">
                    <div className="message-detail">
                        <div className="agreement-message">
                            <p>{'A default payment method is required to process platform fee charges. This card will be used automatically to charge the platform fee.'}</p>
                        </div>

                        <a className="billing-link" style={{ textDecoration: "underline" }} onClick={() => openDefaultPaymentMethod()}>
                            Set Default Payment Methods
                        </a>
                    </div>
                </div>
            </div>
            </> : null
        )
    }
    // Payment Methods Functions <<<

    return (
        Sgl?.current_user?.sgl_id ?
        <>
        {
            !displayAgreement && !displayPaymentMethods ?
            <>
                {renderUnsignedAgreements()}
                {renderDefaultPaymentMethod()}
            </> : null
        }

        {
            displayAgreement && selectedAgreement ?
            <AgreementDetail agreement={selectedAgreement} handleClose={closeAgreementDetail}/> : null
        }

        {
            displayPaymentMethods ?
            <SetDefaultPaymentMethod handleClose={closeDefaultPaymentMethod}/> : null
        }
        </> : null
    );
}

export default BillingMessages;